import { useState } from "react";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { leadCaptureConfigured, submitLead } from "../services/leads";

export default function LeadForm() {
  const [status, setStatus] = useState("idle");
  const [message, setMessage] = useState("");

  async function handleSubmit(event) {
    event.preventDefault();
    const form = event.currentTarget;
    setStatus("loading");
    setMessage("");
    const data = Object.fromEntries(new FormData(form));

    try {
      const result = await submitLead(data);
      setStatus("success");
      setMessage(result.preview
        ? "Formulário validado para a apresentação. A integração de leads será ativada após a aprovação."
        : "Obrigado! Recebemos seus dados e entraremos em contato.");
      if (!result.preview) form.reset();
    } catch {
      setStatus("error");
      setMessage("Não foi possível enviar agora. Tente novamente em instantes.");
    }
  }

  return (
    <form className="lead-form" onSubmit={handleSubmit}>
      <label>Nome completo *<input type="text" name="name" autoComplete="name" required /></label>
      <label>E-mail *<input type="email" name="email" autoComplete="email" required /></label>
      <label>Telefone / WhatsApp *<input type="tel" name="phone" autoComplete="tel" required /></label>
      <label>Seu perfil
        <select name="profile" defaultValue="Quero morar">
          <option>Quero morar</option>
          <option>Quero investir</option>
          <option>Sou corretor(a)</option>
          <option>Ainda não sei</option>
        </select>
      </label>
      <label>Mensagem<textarea name="message" rows="3" /></label>
      <label className="consent"><input type="checkbox" name="consent" required /> <span>{leadCaptureConfigured ? "Autorizo o contato da equipe sobre o Urban Square." : "Entendo que este formulário é uma demonstração e não envia dados."}</span></label>
      <button className="button button-block" type="submit" disabled={status === "loading"}>
        {status === "loading" ? "Enviando..." : "Receber o material completo"}
        {status === "success" ? <CheckCircle2 aria-hidden="true" /> : <ArrowRight aria-hidden="true" />}
      </button>
      <p className="form-note">{leadCaptureConfigured ? "Seus dados serão usados para atender à sua solicitação." : "Versão de aprovação: a captação de leads ainda não está ativada."}</p>
      <p className={`form-feedback ${status === "error" ? "is-error" : ""}`} role="status">{message}</p>
    </form>
  );
}
